import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-46fd2fd4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2"
  }, "生产趋势", -1);
});
var _hoisted_6 = {
  class: "box mb-4"
};
var _hoisted_7 = {
  key: 0,
  class: "box mb-4"
};
var _hoisted_8 = {
  class: "hostSummary"
};
var _hoisted_9 = {
  class: "mb-2 table cus-table"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "标号"), /*#__PURE__*/_createElementVNode("th", null, "配比号"), /*#__PURE__*/_createElementVNode("th", null, "产量/吨"), /*#__PURE__*/_createElementVNode("th", null, "部位")], -1);
});
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "5"
  }, "暂无数据", -1);
});
var _hoisted_13 = [_hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_c_title = _resolveComponent("c-title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    showBtn: false,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["type", "onConfirmDate"]), _createElementVNode("div", _hoisted_2, "本" + _toDisplayString(_ctx.title) + "砂浆总汇", 1), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.material_name
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _hoisted_5, _createElementVNode("div", _hoisted_6, [_ctx.mainPro.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mainPro)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))]), _ctx.params.type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_ctx.mainProYear.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mainProYear)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_c_title, {
    title: "产量总汇"
  }), _createElementVNode("table", _hoisted_9, [_hoisted_10, _ctx.mortarSumGroup.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.mortarSumGroup, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.grade), 1), _createElementVNode("td", null, _toDisplayString(item.match_num), 1), _createElementVNode("td", null, _toDisplayString(item.preload), 1), _createElementVNode("td", null, _toDisplayString(item.position), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))])])]);
}